import Box from '@mui/material/Box'

import * as React from 'react'
import * as ReactRouter from 'react-router-dom'
import { TagCloud } from 'react-tagcloud'
import { Loading, SIZES } from 'components/loading/component'
import { Logo } from 'components/images/logo'
import 'components/styles/main.scss'

import { tagRenderer } from './renderer'
import './styles.scss'

import { emptyState, noTag, toTagCloud, Topic } from './types'

declare const RASA_HUBSPOT_API_ENDPOINT: string
declare const RASA_HUBSPOT_API_PREFIX: string

interface SelectedTopicProps {
  selected: Topic
}

const SelectedTopic = (props: SelectedTopicProps) => {
  return <Box sx={{
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  }}>
    <div className="tag">
      <span className="title">Label:</span>
      <span className="value">{props.selected.title}</span>
    </div>
    <div className="count">
      <span className="title">Count:</span>
      <span className="value">{props.selected.num_clicks}</span>
    </div>
    <div className="first_click">
      <span className="title">First Click:</span>
      <span className="value">{props.selected.first_click}</span>
    </div>
    <div className="last_click">
      <span className="title">Recent Click:</span>
      <span className="value">{props.selected.last_click}</span>
    </div>
  </Box>
}

export const Topics = () => {
  const { search } = ReactRouter.useLocation();
  const [error, setError] = React.useState(null);
  const [selectedTag, selectTag] = React.useState(noTag)
  const [isLoaded, setIsLoaded] = React.useState(false);
  const [data, setData] = React.useState(emptyState);

  // Note: the empty deps array [] means
  // this useEffect will run once
  // similar to componentDidMount()
  React.useEffect(() => {
    fetch(`${RASA_HUBSPOT_API_ENDPOINT}${RASA_HUBSPOT_API_PREFIX}/topics${search}`)
      .then(res => {
        if (res.ok) {
          return res.json()
        } else {
          throw Error('Error getting response')
        }
      })
      .then(
        (result) => {
          setIsLoaded(true);
          setData(result);
        },
        (ex) => {
          setIsLoaded(true);
          setError(ex);
        }
      )
  }, [])

  if ( error ) {
    return (
      <div className="main">
        <Logo/>
        <div>Problem loading the topic cloud</div>
      </div>
    )
  } else if (!isLoaded ) {
    return (
      <div className="main">
        <Logo/>
        <Loading size={SIZES.LARGE}/>
      </div>
    )
  } else {
    return (
      <div className="tag-cloud-main main">
        <Box  sx={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'no-wrap',
          justifyContent: 'left',
          alignItems: 'flex-start',
          p: 1,
          m: 1,
          bgcolor: 'background.paper',
          borderRadius: 1,
        }}>
          <div className="tag-cloud-container">
            <TagCloud minSize={12} maxSize={36}
                      tags={toTagCloud((data || {}).results || [])}
                      onClick={(tag) => selectTag(tag)}
                      renderer={(tag, size, color) => tagRenderer(tag, size, color, selectedTag)}/>
          </div>
          { selectedTag.topic &&
          <div className="selected-tag-container">
            <SelectedTopic selected={selectedTag.topic}/>
          </div>}
        </Box>
      </div>
    )
  }
}
